import { FC, useEffect } from "react";
import { Paper, Box, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import __ from "src/utils/Translations";
import EmployeeAutocomplete from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Components/Autocomplete/EmployeeAutocomplete";
import OrgchartSelect from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Shared/OrgchartSelect";
import useOrgchartEmployeesStore from "./store";
import { fetchEmployeeInOrgchart } from "./api";

interface IEmployeesFilterBar {
  companyId: string;
  structureId: string;
}

const FilterBar: FC<IEmployeesFilterBar> = ({ companyId, structureId }) => {
  const theme = useTheme();
  const { setNodeToFocusOn, searchedNodeId } = useOrgchartEmployeesStore();

  const { data: hierarchyData } = useQuery({
    queryKey: ["employeeInOrgchart", searchedNodeId, companyId, structureId],
    queryFn: () =>
      fetchEmployeeInOrgchart(companyId, structureId, searchedNodeId!),
    enabled: !!searchedNodeId,
  });

  useEffect(() => {
    if (hierarchyData && searchedNodeId) {
      const store = useOrgchartEmployeesStore.getState();
      store.setHierarchyData(hierarchyData);
      store.setWasSearchTriggered(true);
      store.paginationCursors.clear();
    }
  }, [hierarchyData, searchedNodeId]);

  return (
    <Paper sx={{ p: 2 }} data-testid="os__view-filter-bar">
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          gap: "16px",
          justifyContent: "flex-start",
          [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
          },
        }}
      >
        <OrgchartSelect companyId={companyId} />
        <EmployeeAutocomplete
          name="autocomplete"
          label={__("Szukaj")}
          onSubmit={() => {
            setNodeToFocusOn(undefined);
          }}
        />
      </Box>
    </Paper>
  );
};

export default FilterBar;
